<template>
  <option-general value="scroll" :label="$t('edit.sidebar.on_scroll')">
    <div>
      <select
        class="klickart-select"
        @change="boxUpdateConfig({ item: 'advanced', key: 'exibition_mode_scroll_value', value: $event.target.value });">
        <option
          value="25"
          :selected="boxConfig.advanced.exibition_mode_scroll_value === '25'">
          {{ $t('edit.sidebar.until_page_top') }}
        </option>
        <option
          value="50"
          :selected="boxConfig.advanced.exibition_mode_scroll_value === '50'">
          {{ $t('edit.sidebar.until_page_middle') }}
        </option>
        <option
          value="75"
          :selected="boxConfig.advanced.exibition_mode_scroll_value === '75'">
          {{ $t('edit.sidebar.until_page_bottom') }}
        </option>
      </select>
    </div>
  </option-general>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import OptionGeneral from './general/Main.vue';

export default {
  components: {
    OptionGeneral,
  },
  methods: mapActions([
    'boxUpdateConfig',
  ]),
  computed: mapGetters({
    boxConfig: 'boxConfig',
  }),
};
</script>
exibition_mode_time_value



/** WEBPACK FOOTER **
 ** Scroll.vue?55c387b0
 **/